const supportCodeExts = [
  'py',
  'java',
  'c',
  'cpp',
  'h',
  'cs',
  'js',
  'ts',
  'php',
  'rb',
  'go',
  'rs',
  'kt',
  'css',
  'scss',
  'lua',
  'scala',
  'jsx',
  'tsx',
  'xml',
  'yaml',
  'sh',
  'groovy',
  'm',
  'f',
  'toml',
]

const wpsSupportExts = [
  'doc',
  'dot',
  'wps',
  'wpt',
  'docx',
  'dotx',
  'docm',
  'dotm',
  'rtf',
  'txt',
  'xml',
  'mhtml',
  'mht',
  'html',
  'htm',
  'uof',
  'uot3',
  'xls',
  'xlt',
  'et',
  'xlsx',
  'xltx',
  'csv',
  'xlsm',
  'xltm',
  'ett',
  'ppt',
  'pptx',
  'pptm',
  'ppsx',
  'ppsm',
  'pps',
  'potx',
  'potm',
  'dpt',
  'dps',
  'pot',
  'pdf',
  'ofd',
  'otl',
  'dbt',
]

const supportImageExts = ['jpg', 'jpeg', 'png', 'webp', 'gif']

const supportAudioExts = ['mp3', 'wav', 'flac', 'alac', 'aac', 'ogg', 'webm', 'opus', 'wma', 'm4a']

const supportVideoExts = ['avi', 'mp4', 'mov', 'mkv', 'flv', 'wmv']

const supportTextExts = [
  'docx',
  'doc',
  'xlsx',
  'xls',
  'csv',
  'txt',
  'pdf',
  'epub',
  'md',
  'html',
  'htm',
]

const supportFileExts = [
  ...supportTextExts,
  ...supportVideoExts,
  ...supportAudioExts,
  ...supportImageExts,
  ...supportCodeExts,
]

const extReg = /\.([a-zA-Z]+)$/

export const getExt = (ext: string) => {
  const matched = ext.match(extReg)
  if (matched && matched.length >= 2) {
    ext = matched[1]
  }
  return ext
}

export const isSupportFile = (ext: string) => {
  return supportFileExts.includes(getExt(ext))
}

export const isWpsSupportExts = (ext: string) => {
  return wpsSupportExts.includes(getExt(ext))
}

export const isTxtExts = (ext: string) => {
  return getExt(ext) === 'txt'
}

export const isMdExts = (ext: string) => {
  return getExt(ext) === 'md'
}

export const extIconsMap: Record<string, string> = {
  xlsx: 'https://p0.ssl.qhimg.com/t110b9a93012f88f540782c47e6.png',
  xls: 'https://p0.ssl.qhimg.com/t110b9a93012f88f540782c47e6.png',
  ppt: 'https://p1.ssl.qhimg.com/t110b9a9301b454bcda7d250f62.png',
  pptx: 'https://p1.ssl.qhimg.com/t110b9a9301b454bcda7d250f62.png',
  txt: 'https://p0.ssl.qhimg.com/t110b9a93017bf590d48499a83c.png',
  doc: 'https://p4.ssl.qhimg.com/t110b9a93019744736e51dfbf63.png',
  docx: 'https://p4.ssl.qhimg.com/t110b9a93019744736e51dfbf63.png',
  epub: 'https://p5.ssl.qhimg.com/t110b9a930149d2b692e9ff3ccd.png',
  pdf: 'https://p3.ssl.qhimg.com/t110b9a9301c144674dff10a146.png',
  unknown: 'https://p0.ssl.qhimg.com/t110b9a93018da2f394c900083a.png',
  html: 'https://p4.ssl.qhimg.com/t110b9a930192b8ec0c9c9ad56d.png',
  htm: 'https://p4.ssl.qhimg.com/t110b9a930192b8ec0c9c9ad56d.png',
  folder: 'https://p1.ssl.qhimg.com/t110b9a9301c1ac6750f76f680d.png',
  md: 'https://p5.ssl.qhimg.com/t110b9a93014494a244a316a54a.png',
  ...supportImageExts.reduce((acc, ext) => {
    acc[ext] = 'https://p3.ssl.qhimg.com/t110b9a9301ee2db26d7f74594a.png'
    return acc
  }, {} as Record<string, string>),
  ...supportVideoExts.reduce((acc, ext) => {
    acc[ext] = 'https://p4.ssl.qhimg.com/t110b9a9301b4dce054bf0bed00.png'
    return acc
  }, {} as Record<string, string>),
  ...supportAudioExts.reduce((acc, ext) => {
    acc[ext] = 'https://p5.ssl.qhimg.com/t110b9a93016494a65f999d6a8c.png'
    return acc
  }, {} as Record<string, string>),
  ...supportCodeExts.reduce((acc, ext) => {
    acc[ext] = 'https://p3.ssl.qhimg.com/t110b9a9301c85810a932056a35.png'
    return acc
  }, {} as Record<string, string>),
}

export const extLargeIconsMap: Record<string, string> = {
  xlsx: 'https://p5.ssl.qhimg.com/t110b9a9301325b24a907a1c8e8.png',
  xls: 'https://p5.ssl.qhimg.com/t110b9a9301325b24a907a1c8e8.png',
  ppt: 'https://p4.ssl.qhimg.com/t110b9a93011bf1170a308145c0.png',
  pptx: 'https://p4.ssl.qhimg.com/t110b9a93011bf1170a308145c0.png',
  txt: 'https://p0.ssl.qhimg.com/t110b9a9301bbc1e01b681d29d7.png',
  doc: 'https://p0.ssl.qhimg.com/t110b9a9301f02c8f5d557c23c8.png',
  docx: 'https://p0.ssl.qhimg.com/t110b9a9301f02c8f5d557c23c8.png',
  epub: 'https://p5.ssl.qhimg.com/t110b9a930171bda74dc9e34d6a.png',
  pdf: 'https://p5.ssl.qhimg.com/t110b9a9301f520be2e1cb8ad06.png',
  unknown: 'https://p1.ssl.qhimg.com/t110b9a93019bb06b090367707f.png',
  html: 'https://p1.ssl.qhimg.com/t110b9a93012b4cb7f779c2b234.png',
  htm: 'https://p1.ssl.qhimg.com/t110b9a93012b4cb7f779c2b234.png',
  folder: 'https://p3.ssl.qhimg.com/t110b9a930148a3d8ba8a839c73.png',
  md: 'https://p1.ssl.qhimg.com/t110b9a9301262cb124e10ac5de.png',
  ...supportImageExts.reduce((acc, ext) => {
    acc[ext] = 'https://p1.ssl.qhimg.com/t110b9a93018001789ded093331.png'
    return acc
  }, {} as Record<string, string>),
  ...supportVideoExts.reduce((acc, ext) => {
    acc[ext] = 'https://p4.ssl.qhimg.com/t110b9a9301898aaf82d6748dce.png'
    return acc
  }, {} as Record<string, string>),

  ...supportAudioExts.reduce((acc, ext) => {
    acc[ext] = 'https://p4.ssl.qhimg.com/t110b9a9301905bae68826372ed.png'
    return acc
  }, {} as Record<string, string>),
  ...supportCodeExts.reduce((acc, ext) => {
    acc[ext] = 'https://p4.ssl.qhimg.com/t110b9a9301b2fd6380f943d987.png'
    return acc
  }, {} as Record<string, string>),
}
